import { colors } from '@configs/styles/config'
import { SVGProps } from 'react'
import * as React from 'react'

export const StudentConnectBenefitIcon: React.FC<SVGProps<SVGSVGElement>> = (
  props
) => (
  <svg
    width="58"
    height="58"
    viewBox="0 0 58 58"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
  >
    <g clipPath="url(#clip0_3811_26228)">
      <path
        d="M45.9167 9.66667H43.2559C42.1322 4.15908 37.2505 0 31.4167 0H12.0833C5.42058 0 0 5.42058 0 12.0833V43.1472C0 45.066 1.05125 46.8205 2.7405 47.7243C3.509 48.1376 4.35242 48.3406 5.19342 48.3406C6.19875 48.3406 7.20167 48.0482 8.06925 47.4706L15.1984 42.717C16.8683 47.3933 21.3392 50.75 26.5833 50.75H40.3511L49.9307 57.1373C50.8008 57.7173 51.8013 58.0097 52.8066 58.0097C53.6476 58.0097 54.4886 57.8042 55.2595 57.391C56.9512 56.4872 58 54.7327 58 52.8138V21.75C58 15.0873 52.5794 9.66667 45.9167 9.66667ZM5.38917 43.4493C5.34325 43.4783 5.20792 43.5653 5.02183 43.4662C4.83092 43.3647 4.83092 43.2028 4.83092 43.1496V12.0833C4.83092 8.08617 8.08375 4.83333 12.0809 4.83333H31.4143C35.4114 4.83333 38.6643 8.08617 38.6643 12.0833V29C38.6643 32.9972 35.4114 36.25 31.4143 36.25H16.9143C16.124 36.25 15.6068 36.6343 15.5488 36.6729L5.38917 43.4493ZM53.1667 52.8163C53.1667 52.867 53.1667 53.0313 52.9758 53.1328C52.7848 53.2319 52.6543 53.1449 52.6108 53.1159L42.4246 46.3227C42.0283 46.0592 41.5618 45.9167 41.0833 45.9167H26.5833C23.432 45.9167 20.7471 43.8963 19.749 41.0833H31.4167C38.0794 41.0833 43.5 35.6628 43.5 29V14.5H45.9167C49.9138 14.5 53.1667 17.7528 53.1667 21.75V52.8163Z"
        fill={props.color ? props.color : colors.uguPurple}
      />
    </g>
    <defs>
      <clipPath id="clip0_3811_26228">
        <rect width="58" height="58" fill="white" />
      </clipPath>
    </defs>
  </svg>
)
